import { useAdminAccess } from "src/hooks/useAdminAccess";
import { StyledContainer } from "./styles";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import useProject from "../../hooks/useProject";
import InlineSVG from "react-inlinesvg";
import Chat from "./Chat";
import { useToast } from "../ToastWrapper";

export default function StoryChat({ subscriptionJSON, user, userData }) {
  const { projectId } = useParams();

  const topRef = useRef(null);

  const [adminOpen, setAdminOpen] = useState(false);
  const { can } = useAdminAccess();
  const admin = can("admin.tools");
  const [saveError, setSaveError] = useState(false);
  const { setToast } = useToast();

  const [outOfQuota, setOutOfQuota] = useState(false);

  const abortController = useRef(new AbortController());
  const [isStreaming, setIsStreaming] = useState(false);

  const project = useProject({ projectId });

  useEffect(() => {
    if (subscriptionJSON?.totalQuota <= 0) {
      setOutOfQuota(true);
    }
  }, [subscriptionJSON]);

  useEffect(() => {
    if (saveError) {
      setToast(saveError);
      setSaveError(false);
    }
  }, [saveError]);

  // Toggle the admin menu when ⌘L is pressed
  useEffect(() => {
    if (admin) {
      const down = (e) => {
        if (e.key === "l" && e.metaKey) {
          setAdminOpen((open) => !open);
        }
      };

      document.addEventListener("keydown", down);
      return () => document.removeEventListener("keydown", down);
    }
  }, []);

  return (
    <StyledContainer>
      <div className="inner">
        <div
          className="anchor"
          ref={topRef}
        ></div>

        <div className="close">
          <Link to={`/app/project/${projectId}`}>
            <InlineSVG src="/assets/brainstorm/close-modal.svg" />
          </Link>
        </div>

        <div className="container">
          <div className="section">
            <h2>Chat</h2>
            <Chat

              projectId={projectId}
            />
          </div>
        </div>
      </div>
    </StyledContainer>
  );
}
